<template>
	<div class="tags">
		<ul v-show="value.length" class="tags__list">
			<li v-for="(tag, idx) in value" :key="idx">
				<span v-if="tag" class="tags__tag" v-text="tag" />
			</li>
		</ul>
		<input
			:value="pouchTagsText"
			type="text"
			placeholder="콤마(,)단위로등록하세요. ex) 글로우픽,캐스트,글로우픽캐스트,캐스트좋아요"
			class="tags__input"
			@input="pouchTagsTextInput"
		/>
	</div>
</template>
<script>
	export default {
		name: 'CastTags',
		props: {
			value: {
				type: Array,
				default: [],
			},
			pouchTagsText: {
				type: String,
				default: '',
			},
		},
		methods: {
			pouchTagsTextInput(e) {
				const text = e.target.value;
				const tags = text
					.split(',')
					.filter(tag => tag.trim().length > 0)
					.map(tag => tag.trim())
					.reduce((acc, tag) => {
						if (acc.indexOf(tag) < 0) {
							acc.push(tag);
						}
						return acc;
					}, []);
				this.$emit('input', tags);
				this.$emit('inputText', text);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.tags {
		display: block;
		width: 100%;

		&__list {
			display: flex;
			flex-wrap: wrap;
		}

		&__tag {
			display: block;
			padding: 6px 12px;
			margin: 0 6px 6px 0;
			background: $btn-blue;
			color: #fff;
			font-weight: bold;
			border-radius: 16px;
		}

		&__input {
			display: block;
			width: 100%;
		}
	}
</style>
